/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationsRecordResponse } from './NotificationsRecordResponse';
import {
    NotificationsRecordResponseFromJSON,
    NotificationsRecordResponseFromJSONTyped,
    NotificationsRecordResponseToJSON,
} from './NotificationsRecordResponse';

/**
 * 
 * @export
 * @interface NotificationsPaginatedRecordsResponse
 */
export interface NotificationsPaginatedRecordsResponse {
    /**
     * 
     * @type {number}
     * @memberof NotificationsPaginatedRecordsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationsPaginatedRecordsResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationsPaginatedRecordsResponse
     */
    count: number;
    /**
     * 
     * @type {Array<NotificationsRecordResponse>}
     * @memberof NotificationsPaginatedRecordsResponse
     */
    results: Array<NotificationsRecordResponse>;
}

/**
 * Check if a given object implements the NotificationsPaginatedRecordsResponse interface.
 */
export function instanceOfNotificationsPaginatedRecordsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function NotificationsPaginatedRecordsResponseFromJSON(json: any): NotificationsPaginatedRecordsResponse {
    return NotificationsPaginatedRecordsResponseFromJSONTyped(json, false);
}

export function NotificationsPaginatedRecordsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsPaginatedRecordsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'count': json['count'],
        'results': ((json['results'] as Array<any>).map(NotificationsRecordResponseFromJSON)),
    };
}

export function NotificationsPaginatedRecordsResponseToJSON(value?: NotificationsPaginatedRecordsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(NotificationsRecordResponseToJSON)),
    };
}

